<template>
    <auth-layout>
        <header-page title="Data Diri"/>
        <loading-block v-if="loading" />
        <div v-else>
            <div class="profile-wrap">
                <upload-avatar :user="user" @changed="handleChangeAvatar"/>
                <div class="profile-list">
                    <div class="profile-list-title">Username</div>
                    <div class="profile-list-value">{{ user.username }}</div>
                </div>
                <div class="profile-list">
                    <div class="profile-list-title">Nama Lengkap</div>
                    <div class="profile-list-value">{{ user.fullname }} {{ user.lastname ? user.lastname : '' }}</div>
                </div>
                <div class="profile-list">
                    <div class="profile-list-title">Email</div>
                    <div class="profile-list-value">{{ user.email }}</div>
                </div>
                <div class="profile-list">
                    <div class="profile-list-title">Bio</div>
                    <div class="profile-list-value">{{ user.bio }}</div>
                </div>
                <div class="profile-list">
                    <div class="profile-list-title">Alamat</div>
                    <div class="profile-list-value">{{ user.address }}</div>
                </div>
                <div class="profile-list">
                    <div class="profile-list-title">Jenis Kelamin</div>
                    <div class="profile-list-value">{{ user.gender }}</div>
                </div>
                <div class="profile-list">
                    <div class="profile-list-title">Handphone</div>
                    <div class="profile-list-value">{{ user.phone !== '0' ? user.phone : ''}}</div>
                </div>
                <div class="profile-list">
                    <div class="profile-list-title">Tanggal Lahir</div>
                    <div class="profile-list-value">{{ user.brithday !== '0000-00-00' ? moment(user.brithday) : ''  }}</div>
                </div>
                <div class="profile-list">
                    <div class="profile-list-title">Pekerjaan</div>
                    <div class="profile-list-value" v-if="user.job_id && user.job_id != 0">{{ user.jobs.name }}</div>
                </div>
                <div class="profile-list" v-if="user.register_log == 'arkadiame'">
                    <div class="profile-list-title">Facebook</div>
                    <div class="profile-list-value"><table align="center"><tr><td>{{ user.facebook }}</td></tr><tr><td>{{ user.facebook_follower }}</td></tr></table></div>
                </div>
                <div class="profile-list" v-if="user.register_log == 'arkadiame'">
                    <div class="profile-list-title">Instagram</div>
                    <div class="profile-list-value"><table align="center"><tr><td>{{ user.instagram }}</td></tr><tr><td>{{ user.instagram_follower }}</td></tr></table></div>
                </div>
                <div class="profile-list" v-if="user.register_log == 'arkadiame'">
                    <div class="profile-list-title">Twitter</div>
                    <div class="profile-list-value"><table align="center"><tr><td>{{ user.twitter }}</td></tr><tr><td>{{ user.twitter_follower }}</td></tr></table></div>
                </div>
                 <div class="profile-list" v-if="user.register_log == 'arkadiame'">
                    <div class="profile-list-title">Tiktok</div>
                    <div class="profile-list-value"><table align="center"><tr><td>{{ user.tiktok }}</td></tr><tr><td>{{ user.tiktok_follower }}</td></tr></table></div>
                </div>
                <div class="profile-list">
                    <div class="profile-list-title">Provinsi</div>
                    <div class="profile-list-value" v-if="user.province !=null">{{ user.province.name }}</div>
                </div>
                <div class="profile-list">
                    <div class="profile-list-title">Kota</div>
                    <div class="profile-list-value" v-if="user.regency !=null">{{ user.regency.name }}</div>
                </div>
            </div>
            <div class="button-wrap">
                <router-link :to="{ name: 'profile-edit' }" class="btn btn-primary main-button pill-button">Edit Data Diri</router-link>
                <router-link :to="{ name: 'profile-edit-password' }" class="btn btn-primary main-button pill-button">Edit Password</router-link>
<!--                <router-link :to="{ name: 'verification' }" class="btn btn-primary main-button pill-button bg-blue">Verifikasi</router-link>-->
            </div>
        </div>
    </auth-layout>
</template>
<script>
import axios from "axios";
import moment from "moment";

export default {
    data() {
        return {
            user: {},
            loading: true
        }
    },
    mounted() {
        this.getUser()
    },
    methods: {
        getUser () {
            const token = this.$cookies.get('token');
            axios.get('/api/user', { headers: {"Authorization" : `Bearer ${token}`} })
                .then((response) => {
                    var myObj = response.data
                    if(response.data.gender === 2) {
                        myObj['gender'] = 'Laki - laki'
                    } else if (response.data.gender === 1) {
                        myObj['gender'] = 'Perempuan'
                    } else {
                        myObj['gender'] = ''
                    }
                    this.user = response.data
                    this.loading = false
                })
                .catch((error) => {

                });
        },
        handleChangeAvatar(status) {
            if(status) {
                this.getUser();
            }
        },
        moment (date) {
            return moment(date, "YYYY-MM-DD").format("DD-MM-YYYY");
        },
    }
}
</script>
<style scoped>
.profile-wrap {
    padding: 0 5%;
}
.profile-list {
    text-align: center;
    margin-bottom: 20px;
}
.profile-list-title {
    color: #828282;
}
.profile-list-value {
    font-family: "Poppins", sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 22px;
    color: #333333;
    word-wrap:break-word;
}
</style>
